import { j as e } from "./index-5HZ18Wug.js";
import { u as p } from "./useTransitionState-9D4Z4_FK.js";
import { styled as r } from "styled-components";
import { j as m } from "./style-V_Aar-SK.js";
const o = r.div`
  ${m("opacity")}

  opacity: ${({ $visible: t }) => +!!t};
`, g = r.div`
  display: grid;
  grid-template-rows: 100%;
  grid-template-columns: 100%;
  width: 100%;
  > ${o} {
    grid-row-start: 1;
    grid-column-start: 1;
  }
`, y = ({ visible: t, children: s }) => {
  const [n, i, a] = p(t, ["opacity"]);
  return !n && !i ? null : /* @__PURE__ */ e.jsx(o, { $visible: i, onTransitionEnd: a, children: s });
};
export {
  g as O,
  y as T
};
